import { render } from "./HostAdd.vue?vue&type=template&id=2b6b5634"
import script from "./HostAdd.vue?vue&type=script&lang=js"
export * from "./HostAdd.vue?vue&type=script&lang=js"

import "./HostAdd.vue?vue&type=style&index=0&id=2b6b5634&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__